export default "__VITE_ASSET__CBoQuWHe__"